import {
  GET_OFFICES,
  CREATE_OFFICES,
  DELETE_OFFICES,
  UPDATE_OFFICES,
  API_RESPONSE_SUCCESS,
  API_RESPONSE_ERROR,
  GET_OFFICES_BY_ID,
} from './actionType';

const INIT_STATE = {
  offices: null,
  officesById: null,
  error: {},
  success: '',
};

const Offices = (state = INIT_STATE, action) => {
  switch (action.type) {
    case API_RESPONSE_SUCCESS:
      switch (action.payload.actionType) {
        case GET_OFFICES:
          return {
            ...state,
            offices: action.payload.data,
            success: '',
            error: {},
          };
        case GET_OFFICES_BY_ID:
          return {
            ...state,
            officesById: action.payload.data,
            success: '',
            error: {},
          };
        case CREATE_OFFICES:
          return {
            ...state,
            success: 'Sucessfully created plans',
            error: {},
          };
        case UPDATE_OFFICES:
          return {
            ...state,
            success: 'Sucessfully updated plans',
            error: {},
          };
        case DELETE_OFFICES:
          return {
            ...state,
            success: 'Sucessfully delete plans',
            error: {},
          };
        default:
          return { ...state };
      }
    case API_RESPONSE_ERROR:
      switch (action.payload.actionType) {
        case GET_OFFICES:
          return {
            ...state,
            success: '',
            error: action.payload.response.data.message,
          };
        case GET_OFFICES_BY_ID:
          return {
            ...state,
            success: '',
            error: action.payload.error,
          };
        case CREATE_OFFICES:
          return {
            ...state,
            success: '',
            error: action.payload.response.data.message,
          };
        case UPDATE_OFFICES:
          return {
            ...state,
            success: '',
            error: action.payload.response.data.message,
          };
        case DELETE_OFFICES:
          return {
            ...state,
            success: '',
            error: action.payload.response.data.message,
          };
        default:
          return { ...state };
      }
    case GET_OFFICES: {
      return {
        ...state,
      };
    }
    case CREATE_OFFICES: {
      return {
        ...state,
      };
    }
    case UPDATE_OFFICES: {
      return {
        ...state,
      };
    }
    case DELETE_OFFICES: {
      return {
        ...state,
      };
    }
    case GET_OFFICES_BY_ID: {
      return {
        ...state,
      };
    }
    default:
      return { ...state };
  }
};

export default Offices;
